import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

export type ButtonVariant =
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link"
    | "hero"
    | "orange"
    | "green"
    | "blue"
    | "white";

@Component({
    selector: "app-button",
    templateUrl: "./button.component.html",
    styleUrl: "./button.component.scss",
    standalone: false,
})
export class ButtonComponent {
    @Input() variant!: ButtonVariant;
    @Input() class: string = ""; // Goes to host (positioning/layout)
    @Input() buttonClass: string = ""; // Goes to button (styling)
    @Input() size: "normal" | "sm" | "lg" | "xl" | "icon" = "normal";
    @Input() disabled: boolean = false;

    @Output() onClick = new EventEmitter<Event>();

    @HostBinding("class") get hostClasses() {
        return this.class;
    }

    handleClick(event: Event) {
        if (!this.disabled) {
            this.onClick.emit(event);
        }
    }
}
